import { Space } from 'antd'
import Flex from 'components/Flex'
import React from 'react'

import {
  CompanyName,
  InfoSection,
  RedDot,
  RoleName,
} from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleDetails/Style/style'

const RoleDetails = ({ data }) => {
  let currentDate =  new Date().toJSON()
  return (
    <Flex centerVertically>
      <InfoSection>
        <CompanyName>{data?.jobRoles?.corporate?.name}</CompanyName>
        <RoleName>
          <Space>
            {data?.jobRoles?.tittle} {data?.jobRoles?.endDate<currentDate? null: <RedDot />}
          </Space>{' '}
        </RoleName>
      </InfoSection>
    </Flex>
  )
}

export default RoleDetails

